import { useEffect, useState } from "react";
import { CanceledError } from "axios";
import {
  CatalogDirectoryCategory,
  fetchProductCatalogDirectory,
} from "../api/fetchProductCatalogDirectory";

/**
 * Loads the member-facing catalog directory (published entries, already
 * stage-filtered server-side by the active company's stage).
 */
export function useCatalogDirectory() {
  const [categories, setCategories] = useState<CatalogDirectoryCategory[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const controller = new AbortController();
    fetchProductCatalogDirectory(controller.signal)
      .then((response) => {
        setCategories(response.data);
        setLoading(false);
      })
      .catch((err) => {
        if (err instanceof CanceledError) return;
        setLoading(false);
      });
    return () => controller.abort();
  }, []);

  return { categories, loading };
}

export default useCatalogDirectory;
